<template>
  <v-responsive
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :aspect-ratio="aspectRatio"
    v-bind="sizes"
  >
    <svg
      class="block"
      width="100%"
      height="100%"
      :viewBox="viewBox"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 17.1154C0 7.9332 7.1579 0.5 16 0.5C24.8421 0.5 32 7.9332 32 17.1154C32 26.2976 24.8421 33.7308 16 33.7308C13.6842 33.7308 11.4386 33.2206 9.47368 32.2733L5.05263 36.5V29.2126C1.96491 26.1518 0 21.8522 0 17.1154ZM16.4912 25.3502C20.2105 25.3502 24 22.7996 24 17.9899L23.9298 11.8684C23.9298 10.9211 23.2982 10.2652 22.2456 10.2652C21.2632 10.2652 20.5614 10.9211 20.5614 11.8684V17.9899C20.5614 20.0304 19.0175 22.1437 16.4211 22.1437H16.1404C13.5439 22.1437 12 20.0304 12 17.9899V11.8684C12 10.9211 11.2982 10.2652 10.3158 10.2652C9.26316 10.2652 8.63158 10.8482 8.63158 11.8684V17.9899C8.63158 22.7996 12.4211 25.3502 16.1404 25.3502H16.3509H16.4912Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M148.207 3.70672V10.096C146.802 9.00689 145.046 8.42605 143.22 8.42605C138.514 8.42605 134.721 12.3467 134.721 17.2113C134.721 22.0758 138.514 25.9965 143.22 25.9965C145.117 25.9965 147.013 25.4882 148.418 24.3992C149.823 23.4553 150.455 22.5114 150.876 21.7128C151.649 20.2607 151.789 18.5908 151.789 16.9934V3.56151C151.789 1.52857 148.207 1.60117 148.207 3.70672ZM143.22 22.4388C140.411 22.4388 138.163 20.1155 138.163 17.2113C138.163 14.3071 140.411 11.9837 143.22 11.9837C145.889 11.9837 147.996 14.0892 148.207 16.7756V17.7195C147.996 20.3333 145.819 22.4388 143.22 22.4388ZM54.8607 17.0658V3.63385C54.8607 1.5283 58.4428 1.60091 58.4428 3.70645V10.1683C59.8476 9.15183 61.5333 8.49838 63.4297 8.49838C68.1357 8.49838 71.9286 12.4191 71.9286 17.2836C71.9286 22.1481 68.1357 26.0688 63.4297 26.0688C61.5333 26.0688 59.6369 25.5606 58.2321 24.4715C56.8274 23.455 56.1952 22.5838 55.7738 21.7851C55.0714 20.333 54.8607 18.5905 54.8607 17.0658ZM58.4428 16.7756V17.6469C58.6535 20.3333 60.8309 22.4388 63.4297 22.4388C66.2393 22.4388 68.4869 20.1155 68.4869 17.2113C68.4869 14.3071 66.2393 11.9837 63.4297 11.9837C60.8309 11.9837 58.6535 14.0892 58.4428 16.7756ZM78.7416 4.21496C78.7416 5.33772 77.8297 6.2479 76.7047 6.2479C75.5798 6.2479 74.6678 5.33772 74.6678 4.21496C74.6678 3.09219 75.5798 2.18201 76.7047 2.18201C77.8297 2.18201 78.7416 3.09219 78.7416 4.21496ZM43.3416 8.42605H43.6226C47.9071 8.42605 52.3321 11.3302 52.3321 16.8482V23.8909C52.3321 25.0526 51.5595 25.7787 50.3654 25.7787C49.2416 25.7787 48.3988 24.98 48.3988 23.8909V16.8482C48.3988 14.4523 46.5726 12.0563 43.5524 12.0563H43.2012C40.2512 12.0563 38.425 14.5249 38.425 16.8482V23.8909C38.425 24.98 37.6524 25.7787 36.4583 25.7787C35.2643 25.7787 34.4916 25.0526 34.4916 23.8909V16.8482C34.4916 11.3302 38.9166 8.42605 43.2012 8.42605H43.3416ZM74.8785 9.95075V24.3992C74.8785 25.4882 75.7916 25.9965 76.7047 25.9965C77.6178 25.9965 78.4607 25.4156 78.4607 24.3992V9.95075C78.4607 7.84521 74.8785 7.84521 74.8785 9.95075ZM94.6857 10.096C93.2809 9.00689 91.525 8.42605 89.6988 8.42605C84.9928 8.42605 81.2 12.3467 81.2 17.2113C81.2 22.0758 84.9928 25.9965 89.6988 25.9965C91.5952 25.9965 93.2809 25.343 94.6857 24.2539C94.7559 25.1978 95.5988 25.7787 96.4416 25.7787C97.3547 25.7787 98.1976 25.1978 98.1976 24.1813V10.1686C98.1976 8.06302 94.8262 8.06302 94.6857 10.096ZM89.6285 22.4388C86.819 22.4388 84.5714 20.1155 84.5714 17.2113C84.5714 14.3071 86.819 11.9837 89.6285 11.9837C92.2976 11.9837 94.4047 14.0892 94.6154 16.7756V17.6469C94.4047 20.3333 92.2976 22.4388 89.6285 22.4388ZM124.396 8.42605C129.032 8.42605 132.895 12.3467 132.895 17.2113C132.895 17.2113 132.895 17.2839 132.965 17.2839C132.965 18.0099 132.404 18.6634 131.209 18.6634H129.243H119.62C120.042 20.9867 122.079 22.584 124.748 22.584C127.317 22.584 127.999 22.1129 129.175 21.3002L129.313 21.2045C131.42 19.825 133.106 22.4388 131.209 23.8909C129.454 25.1978 127.627 25.9965 124.677 25.9965C119.971 25.9965 115.898 22.6566 115.898 17.2113C115.898 12.3467 119.69 8.42605 124.396 8.42605ZM124.396 11.9837C122.079 11.9837 120.252 13.4358 119.62 15.6139H129.173C128.54 13.5084 126.714 11.9837 124.396 11.9837ZM108.171 15.4598C106.36 14.9072 104.828 14.4396 104.8 13.2906C104.73 11.9111 106.134 11.5481 107.609 11.4755C109.084 11.4755 109.927 11.9111 110.84 12.5645C112.807 13.944 114.142 11.5481 113.088 10.5316C111.964 9.29731 110.068 8.35344 107.469 8.35344C104.098 8.35344 101.358 10.1686 101.358 13.4358C101.358 17.143 104.701 18.2397 107.358 19.1115C109.176 19.7081 110.674 20.1993 110.559 21.3497C110.419 22.584 109.365 22.9471 107.68 22.8745C105.886 22.8031 104.702 21.9614 103.596 21.1747L103.536 21.1319C101.92 20.1155 99.7428 22.4388 101.569 23.9635C103.536 25.6334 105.081 26.0691 107.82 26.0691C111.192 25.9965 114.071 24.2539 114.071 20.8415C114.071 17.2606 110.822 16.269 108.171 15.4598Z"
        :fill="variant === 'white' ? '#fff' : '#323232'"
      />
      <path
        v-if="pro"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M169.488 3.28181V11.9078C169.488 12.1883 169.488 12.4688 169.767 12.5389C169.977 12.7493 170.326 12.8195 170.605 12.8195C170.953 12.8195 171.233 12.7493 171.442 12.5389C171.651 12.3286 171.721 12.048 171.721 11.7675V7.27921C171.721 5.94674 172.628 5.03505 173.047 4.75453C173.326 4.54414 174.093 4.33375 174.581 4.33375C174.93 4.33375 175.14 4.1935 175.349 3.98311C175.558 3.77272 175.628 3.4922 175.628 3.21168C175.628 2.93116 175.558 2.65064 175.349 2.44025C175.14 2.22986 174.86 2.15973 174.581 2.15973H174.512C173.674 2.15973 172.837 2.44025 172.07 3.00129C171.93 3.07142 171.791 3.21168 171.651 3.42207V3.28181C171.651 3.00129 171.512 2.72077 171.302 2.51038C171.093 2.29999 170.814 2.22986 170.535 2.22986C170.256 2.22986 170.047 2.29999 169.837 2.51038C169.628 2.72077 169.488 3.00129 169.488 3.28181ZM186.512 7.55973C186.512 4.61427 184.14 2.22986 181.209 2.22986C178.349 2.22986 175.977 4.61427 175.907 7.55973C175.907 10.5052 178.279 12.8896 181.209 12.8896C184.14 12.8896 186.512 10.5052 186.512 7.55973ZM184.349 7.55973C184.349 9.31298 182.953 10.7156 181.209 10.7156C179.465 10.7156 178.07 9.31298 178.07 7.55973C178.07 5.80648 179.465 4.40388 181.209 4.40388C182.953 4.40388 184.349 5.80648 184.349 7.55973ZM159.163 11.9078V15.7649C159.163 17.0273 157 17.0273 157 15.7649V7.69999C157 6.7883 157.07 5.73635 157.558 4.89479C157.837 4.40389 158.186 3.84285 159.093 3.28181C159.93 2.58051 161.116 2.29999 162.302 2.29999C165.233 2.29999 167.605 4.6844 167.605 7.62986C167.605 10.5753 165.233 12.9597 162.302 12.9597C161.116 12.9597 160.07 12.5389 159.163 11.9078ZM165.442 7.62986C165.442 5.87661 164.047 4.47401 162.302 4.47401C160.628 4.47401 159.302 5.73635 159.163 7.34934V7.91038C159.302 9.52337 160.698 10.7857 162.302 10.7857C164.047 10.7857 165.442 9.38311 165.442 7.62986Z"
        fill="#782471"
      />
    </svg>
  </v-responsive>
</template>

<script setup lang="ts">
const {
  variant,
  pro,
  width,
  height,
  maxHeight,
  maxWidth,
  minHeight,
  minWidth,
} = defineProps({
  ...useDimensionProps(),
  variant: {
    type: String,
  },
  pro: {
    type: Boolean,
    default: false,
  },
})

const consumerSize = ['152', '37']
const proSize = ['187', '37']

const hasMaxOrMin = computed(() => {
  return !!(maxHeight || maxWidth || minHeight || minWidth)
})
const sizes = computed(() => {
  if (hasMaxOrMin.value) {
    return {}
  }

  if (!width && !height) {
    return {
      width: Number(pro ? proSize[0] : consumerSize[0]),
      height: Number(pro ? proSize[1] : consumerSize[1]),
    }
  }

  const result: Record<string, number> = {}

  if (width) {
    result.width = Number(width)
  }

  if (height) {
    result.height = Number(height)
  }

  return result
})

const viewBox = computed(() => {
  if (pro) {
    return `0 0 ${proSize.join(' ')}`
  }

  return `0 0 ${consumerSize.join(' ')}`
})
const aspectRatio = computed(() => {
  if (pro) {
    return Number(proSize[0]) / Number(proSize[1])
  }

  return Number(consumerSize[0]) / Number(consumerSize[1])
})
const color = computed(() => {
  if (variant === 'white') {
    return '#fff'
  }

  return pro ? '#782471' : '#007b81'
})
</script>
